module.exports = __webpack_public_path__ + "img/card_franchise2.301521d7.svg";